import { AccountStatus } from 'dashboard/models/account-status';
import { AccountType } from 'dashboard/models/account-type';
import Action from 'lib/interfaces/Action';

export type AccountStatusesActions =
  | Action<AccountStatusesActionType.SetAccountStatuses, SetAccountStatusesPayload>
  | Action<AccountStatusesActionType.AddAccountStatuses, AddAccountStatusesPayload>
  | Action<AccountStatusesActionType.UpdateAccountStatus, UpdateAccountStatusPayload>
  | Action<
      AccountStatusesActionType.UpdateDefaultGraphQueryTemplate,
      UpdateDefaultGraphQueryTemplatePayload
    >;

export enum AccountStatusesActionType {
  SetAccountStatuses = 'account-statuses/SET_ACCOUNT_STATUSES',
  AddAccountStatuses = 'account-statuses/ADD_ACCOUNT_STATUSES',
  UpdateAccountStatus = 'account-statuses/UPDATE_ACCOUNT_STATUS',
  UpdateDefaultGraphQueryTemplate = 'account-types/UPDATE_DEFAULT_GRAPH_QUERY_TEMPLATE',
}

interface SetAccountStatusesPayload {
  accountStatuses: AccountStatus[];
  accountType: AccountType;
}

export function setAccountStatuses(
  accountStatuses: AccountStatus[],
  accountType: AccountType,
): Action<AccountStatusesActionType.SetAccountStatuses, SetAccountStatusesPayload> {
  return {
    payload: {
      accountStatuses,
      accountType,
    },
    type: AccountStatusesActionType.SetAccountStatuses,
  };
}

interface AddAccountStatusesPayload {
  accountStatuses: AccountStatus[];
}

export function addAccountStatuses(
  accountStatuses: AccountStatus[],
): Action<AccountStatusesActionType.AddAccountStatuses, AddAccountStatusesPayload> {
  return {
    payload: {
      accountStatuses,
    },
    type: AccountStatusesActionType.AddAccountStatuses,
  };
}

interface UpdateAccountStatusPayload {
  accountStatus: AccountStatus;
}

export function updateAccountStatus(
  accountStatus: AccountStatus,
): Action<AccountStatusesActionType.UpdateAccountStatus, UpdateAccountStatusPayload> {
  return {
    payload: {
      accountStatus,
    },
    type: AccountStatusesActionType.UpdateAccountStatus,
  };
}

interface UpdateDefaultGraphQueryTemplatePayload {
  graphQueryTemplateId: string;
}

export function updateDefaultGraphQueryTemplate(
  graphQueryTemplateId: string,
): Action<
  AccountStatusesActionType.UpdateDefaultGraphQueryTemplate,
  UpdateDefaultGraphQueryTemplatePayload
> {
  return {
    payload: {
      graphQueryTemplateId,
    },
    type: AccountStatusesActionType.UpdateDefaultGraphQueryTemplate,
  };
}
